<div class="page-container">
  <div class="top-spacer"></div>

  <div *ngIf="isLoading$ | async" class="mat-elevation-z1 shimmer-container">
    <div *ngFor="let _ of [].constructor(15)" class="stencil-shimmer shimmer"></div>
  </div>

  <mat-expansion-panel *ngIf="!isUpdate || (isLoading$ | async) === false" class="settings-card" expanded="true">
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.SERVICE.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="settings-card-description">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.SERVICE.DESCRIPTION' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
    <form [formGroup]="form">
      <glxy-form-field>
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.NAME' | translate }}
        </glxy-label>
        <input matInput required formControlName="name" />
        <glxy-error *ngIf="form?.get('name').invalid && (form?.get('name').touched || form?.get('name').dirty)">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.NAME_VALIDATION_REQUIRED' | translate }}
        </glxy-error>
      </glxy-form-field>
      <glxy-form-field [prefixText]="linkPrefix$ | async">
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LINK_LABEL' | translate }}
        </glxy-label>
        <input matInput required formControlName="slug" />
        <button *ngIf="slugChanged" mat-icon-button matSuffix (click)="revertSlug()">
          <mat-icon>undo</mat-icon>
        </button>
        <glxy-error *ngIf="slugFormControl.invalid && (slugFormControl.touched || slugFormControl.dirty)">
          <ng-container *ngIf="slugFormControl.hasError('required'); else checkPattern">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.LINK_VALIDATION_REQUIRED' | translate }}
          </ng-container>

          <ng-template #checkPattern>
            <ng-container *ngIf="slugFormControl.hasError('pattern'); else checkUnique">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.LINK_VALIDATION_PATTERN' | translate }}
            </ng-container>
          </ng-template>

          <ng-template #checkUnique>
            <ng-container *ngIf="slugFormControl.hasError('unique'); else unknownError">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.LINK_VALIDATION_UNIQUE' | translate }}
            </ng-container>
          </ng-template>

          <ng-template #unknownError>
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.LINK_VALIDATION_UNKNOWN' | translate }}
          </ng-template>
        </glxy-error>
      </glxy-form-field>
      <glxy-form-field appearance="outline" class="fullwidth">
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.DESCRIPTION' | translate }}
        </glxy-label>
        <textarea matAutosizeMinRows="4" matInput matTextareaAutosize formControlName="description"></textarea>
      </glxy-form-field>
      <glxy-form-field>
        <div class="color-label">
          <glxy-label>
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.COLOR_LABEL' | translate }}
          </glxy-label>
        </div>
      </glxy-form-field>
      <div class="color-container">
        <button
          *ngFor="let color of colors"
          mat-mini-fab
          class="color-selector"
          [ngStyle]="{ 'background-color': color }"
          (click)="setColor(color)"
        >
          <mat-icon *ngIf="color === form.get('color').value">check</mat-icon>
        </button>
      </div>
    </form>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="!isUpdate || (isLoading$ | async) === false" class="settings-card" expanded="true">
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.SERVICE_EVENT_TYPE.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.SERVICE_EVENT_TYPE.DESCRIPTION' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
    <form [formGroup]="events">
      <div class="event-type-select">
        <glxy-form-field class="form-field">
          <glxy-label>
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.SERVICE_EVENT_TYPE.SELECT' | translate }}
          </glxy-label>
          <mat-select
            #groupSelect
            formControlName="groupList"
            placeholder="{{ 'MEETING_SCHEDULER.BOOKING_LINK.SERVICE_EVENT_TYPE.SELECT_PLACEHOLDER' | translate }}"
            (selectionChange)="onSelectionChange($event)"
            multiple
          >
            <mat-select-trigger>
              {{ groupList.value?.[0]?.name || '' }}
              <span *ngIf="(groupList.value?.length || 0) > 1" class="example-additional-selection">
                (+{{ (groupList.value?.length || 0) - 1 }} {{ groupList.value?.length === 2 ? 'other' : 'others' }})
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let option of listGroups" [value]="option">
              <div class="badge">
                {{ option.name }}
              </div>
            </mat-option>
          </mat-select>
          <glxy-error
            *ngIf="isAssociationsNotSelected && selectedOptions?.length < 2 && (events?.touched || events?.dirty)"
          >
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.GROUP_EVENT_TYPE_VALIDATION_REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
        <glxy-form-field class="form-field">
          <glxy-label>
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.GROUP_EVENT_TYPE.SELECT' | translate }}
          </glxy-label>
          <mat-select
            #eventSelect
            formControlName="eventList"
            placeholder="{{ 'MEETING_SCHEDULER.BOOKING_LINK.GROUP_EVENT_TYPE.SELECT_PLACEHOLDER' | translate }}"
            (selectionChange)="onSelectionChange($event)"
            multiple
          >
            <mat-select-trigger>
              {{ eventList.value?.[0]?.name || '' }}
              <span *ngIf="(eventList.value?.length || 0) > 1" class="example-additional-selection">
                (+{{ (eventList.value?.length || 0) - 1 }} {{ eventList.value?.length === 2 ? 'other' : 'others' }})
              </span>
            </mat-select-trigger>

            <!-- Personal Events -->
            <ng-container *ngIf="personalEventTypes.length">
              <mat-optgroup
                class="event-type-optgroup"
                label="{{ 'MEETING_SCHEDULER.MEETING_LIST.PERSONAL_EVENTS' | translate }}"
              >
                <mat-option *ngFor="let option of personalEventTypes" [value]="option">
                  {{ option.name }}
                </mat-option>
              </mat-optgroup>
            </ng-container>

            <!-- Team Events -->
            <ng-container *ngIf="teamEventTypes.length">
              <mat-optgroup
                class="event-type-optgroup"
                label="{{ 'MEETING_SCHEDULER.MEETING_LIST.TEAM_EVENTS' | translate }}"
              >
                <mat-option *ngFor="let option of teamEventTypes" [value]="option">
                  {{ option.name }}
                </mat-option>
              </mat-optgroup>
            </ng-container>
          </mat-select>
          <glxy-error
            *ngIf="isAssociationsNotSelected && selectedOptions?.length < 2 && (events?.touched || events?.dirty)"
          ></glxy-error>
        </glxy-form-field>
      </div>
      <div class="dynamic-inputs" cdkDropList (cdkDropListDropped)="onDrop($event)">
        <div
          class="dynamic-item"
          *ngFor="let selected of selectedOptions; trackBy: trackById; let i = index"
          cdkDrag
          [cdkDragData]="selected"
        >
          <mat-icon class="drag-icon" aria-hidden="true">drag_indicator</mat-icon>
          <glxy-form-field appearance="outline" class="input-field">
            <div class="input-badge-container">
              <input matInput [value]="selected.name" readonly />
              <mat-icon *ngIf="selected.creator" [glxyTooltip]="selected.creator" class="info-icon" aria-hidden="true"
                >info_outline</mat-icon
              >
              <glxy-badge *ngIf="selected.name && selected.type" [color]="getBadgeColor(selected.type)">
                {{ selected.type.charAt(0).toUpperCase() + selected.type.slice(1) | eventType }}
              </glxy-badge>
            </div>
          </glxy-form-field>

          <mat-icon class="delete-icon" aria-hidden="true" (click)="onDelete(i, selected.type)">
            delete_outline
          </mat-icon>
        </div>
      </div>
    </form>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="isUpdate && (isLoading$ | async) === false"
    class="settings-card day-card"
    expanded="false"
  >
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ADD_TO_WEBSITE.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="Availability-card-description">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ADD_TO_WEBSITE.PROMPT' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
    <div *ngIf="originalSlug !== undefined && originalSlug !== null">
      <meeting-scheduler-settings-add-to-website-card
        [isUpdate]="isUpdate"
        [type]="'service'"
        [id]="serviceId"
        [slug]="originalSlug"
        [name]="serviceName"
      ></meeting-scheduler-settings-add-to-website-card>
    </div>
  </mat-expansion-panel>

  <glxy-sticky-footer [rightAligned]="true" *ngIf="(isLoading$ | async) === false">
    <button
      mat-flat-button
      color="primary"
      type="submit"
      (click)="createOrUpdateService()"
      [disabled]="isButtonLoading$ | async"
    >
      <glxy-button-loading-indicator [isLoading]="isButtonLoading$ | async">{{
        buttonText
      }}</glxy-button-loading-indicator>
    </button>
  </glxy-sticky-footer>
</div>
